/* @ngInject */
function MarketingCalendarController ($scope, $rootScope, $translate, $q, AdminService, BriefingService, TaskTagsService, Utils, ModalService, TasksService, UiElementViewLogService, ToastService, $document, UdsModalService, $stateParams, GroupService, CampaignService, SegmentService, BoardsService) {
  const getNewTaskDialogController = () => $q.when(import('../../../workflow/dialogs/new-task/new-task-dialog.controller'))
  const getRequestFormDialogController = () => $q.when(import('../../../workflow/dialogs/request-form/request-form-dialog.controller'))
  const getRequestDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/request-details/request-details-dialog.controller'))
  const getCreateCampaignDialogController = () => $q.when(import('../../../campaigns/dialogs/create-campaign/create-campaign-dialog.controller'))
  const getCreateTaskDialogController = () => $q.when(import('../../../workflow/dialogs/create-task/create-task-dialog.controller'))

  $scope.headerToolbar = null
  $scope.headerTitle = ''

  $scope.deliveryViewOptions = []
  $scope.viewMode = 'week' // day, week, month
  $scope.lastViewMode = $scope.viewMode
  $scope.locale = ''
  $scope.datePickerType = 'full' // month, full
  $scope.search = ''

  $scope.tasks = {
    items: [],
    count: 0,
    index: 0
  }

  $scope.campaigns = []

  $scope.activities = []
  $scope.tasksFilters = {}
  $scope.loadingTasks = false
  $scope.loadingCampaigns = false
  $scope.showActivities = false
  $scope.showLoadMore = false
  $scope.showMarketingCalendarInfoCard = false
  $scope.features = null

  let currentSkipActivities = 0
  let activityCount = 0

  $scope.date = new Date()

  $scope.activeTabActivities = 'all'

  const api = {
    getNewTaskDialogController,
    getRequestFormDialogController,
    getRequestDetailsDialogController,
    getCreateCampaignDialogController,
    getCreateTaskDialogController,
    _getHeaderInfo,
    _onSearch,
    _onFilter,
    _onOpenActivitiesDropdown,
    _getDeliveryViewOptions,
    _openNewRequest,
    _openNewTask,
    _getUserLocale,
    _loadActivity,
    _loadTasksPerRange,
    _getActivityByType,
    _successGetTasks,
    _getDateRangeOptions,
    _showMarketingCalendarInfoCard,
    _reloadTasksOnCreate,
    _defaultError,
    _getTop,
    _getAllCampaigns,
    _onChangeCalendarType,
    _openNewCampaignDialog,
    _getLastOriginModule,
    _saveOriginModule,
    _openCreateTask,
    _getLastViewMode,
    _saveViewMode
  }

  this.getApi = () => api

  $scope.originModule = $stateParams.originModule || api._getLastOriginModule()
  $scope.viewMode = api._getLastViewMode() || $scope.viewMode
  $scope.deliveryView = $scope.originModule === 'campaigns' ? 'startDate' : 'deliveryDate'

  activate()

  function activate () {
    SegmentService.track('calendar-pageview', {
      page: $scope.originModule
    })

    api._getDeliveryViewOptions()
    api._getUserLocale()
    api._loadTasksPerRange()
    api._showMarketingCalendarInfoCard()

    if ($scope.originModule === 'campaigns') {
      api._getAllCampaigns()
    }

    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      $scope.features = features

      if (!$scope.features?.['WORKFLOW.ACCESS']) {
        $scope.originModule = 'campaigns'
      }
      api._getHeaderInfo()
    })
  }

  const deregisterShowActivitiesWatcher = $scope.$watch('showActivities', (newVal) => {
    if (newVal) {
      setTimeout(() => {
        $document.on('click', handleClickOutsideActivitiesCard)
      }, 100)
    } else {
      $document.off('click', handleClickOutsideActivitiesCard)
    }
  })

  const deregisterReloadTasksWatcher = $rootScope.$on('marketingCalendar.reloadTasks', () => {
    api._loadTasksPerRange()
  })

  const deregisterReopenCreateTaskDialog = $scope.$on('workflow.reopenCreateTaskDialog', (event, data) => {
    api._openCreateTask(data?.createMore)
  })

  const deregisterReloadCampaignsWatcher = $rootScope.$on('marketingCalendar.reloadCampaigns', () => {
    api._getAllCampaigns()
  })

  $scope.closeInfoCard = () => {
    UiElementViewLogService.createElementViewLog('calendar-info-card').then(() => {
      $scope.showMarketingCalendarInfoCard = false
    })
  }

  $scope.$on('$destroy', function () {
    $document.off('click', handleClickOutsideActivitiesCard)
    deregisterShowActivitiesWatcher()
    deregisterReloadTasksWatcher()
    deregisterReopenCreateTaskDialog()
    deregisterReloadCampaignsWatcher()
  })

  $scope.onClickTypeView = (event, type) => {
    const active = event.detail.active
    const datePickerTypes = {
      day: 'full',
      week: 'full',
      month: 'month'
    }

    if (active) {
      $scope.lastViewMode = $scope.viewMode
      $scope.viewMode = type
      $scope.datePickerType = datePickerTypes[type] || 'full'

      if ($scope.originModule === 'campaigns') {
        api._getAllCampaigns()
      } else {
        api._loadTasksPerRange()
      }
    }
  }

  $scope.onChangeDeliveryView = (event) => {
    $scope.deliveryView = event.detail.value

    if ($scope.originModule === 'campaigns') {
      api._getAllCampaigns()
    } else {
      api._loadTasksPerRange()
    }
  }

  $scope.onChangeDatePicker = (event) => {
    $scope.date = new Date(event.detail.date)

    if ($scope.originModule === 'campaigns') {
      api._getAllCampaigns()
    } else {
      api._loadTasksPerRange()
    }
  }

  $scope.onSeeMore = (type, day) => {
    $scope.date = day.value
    $scope.viewMode = type

    if ($scope.originModule === 'campaigns') {
      api._getAllCampaigns()
    } else {
      api._loadTasksPerRange()
    }
  }

  $scope.getDatePickerValue = () => {
    return $scope.date.toISOString()
  }

  $scope.isDayView = () => {
    return $scope.viewMode === 'day'
  }

  $scope.isWeekView = () => {
    return $scope.viewMode === 'week'
  }

  $scope.isMonthView = () => {
    return $scope.viewMode === 'month'
  }

  $scope.loadMoreTasks = () => {
    $scope.tasks.index++
    api._loadTasksPerRange(true)
  }

  $scope.getActivityText = function (activity) {
    const type = activity.type
    const operation = activity.operation
    const value = activity.to

    return api._getActivityByType(type, operation, value, activity)
  }

  $scope.loadMoreActivities = function () {
    api._loadActivity(10, currentSkipActivities, false)
  }

  $scope.handleTabActivitiesChange = (event) => {
    if (event.detail.selected) {
      $scope.activeTabActivities = event.detail.selected
      api._loadActivity(10, 0, true)
    }
  }

  $scope.getDatePickerLabel = () => {
    const date = $scope.date

    const day = Utils.formatDate(date, $scope.locale, {
      day: 'numeric'
    })

    const month = Utils.formatDate(date, $scope.locale, {
      month: 'long'
    })

    const year = Utils.formatDate(date, $scope.locale, {
      year: 'numeric'
    })

    if ($scope.viewMode === 'day') {
      return `${day} ${month} ${year}`
    }

    return `${month} ${year}`
  }

  $scope.openTask = (activity) => {
    const taskId = activity.taskId
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id: taskId
        }
      })
      modal.open()
    })
  }

  function _getHeaderInfo () {
    const showActiveAsDefaultValue = true
    const boardAsDefaultValue = $stateParams.selectedBoard ? {
      label: $stateParams.selectedBoard.name,
      value: $stateParams.selectedBoard.id
    } : null

    const activeItems = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: !!showActiveAsDefaultValue,
      disabled: false
    }

    const filters = [
      {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: showActiveAsDefaultValue ? activeItems : null,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('actives'),
              value: false,
              icon: 'success',
              active: !!showActiveAsDefaultValue,
              disabled: false
            },
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'taskTypes',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [
          {
            label: $translate.instant('requests'),
            value: 'REQUEST',
            icon: 'workflow',
            active: true,
            disabled: false
          },
          {
            label: $translate.instant('tasks'),
            value: 'TASK',
            icon: 'tasks',
            active: true,
            disabled: false
          }
        ],
        props: {
          label: $translate.instant('type'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('requests'),
              value: 'REQUEST',
              icon: 'workflow',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('tasks'),
              value: 'TASK',
              icon: 'tasks',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('subtaskFilter'),
              value: 'SUBTASK',
              icon: 'subtask',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'priorities',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('priorityFilter'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('LOW'),
              value: 'LOW',
              icon: 'chevron-down',
              active: false,
              disabled: false,
              color: 'feedbackColorGreenPure'
            },
            {
              label: $translate.instant('MEDIUM'),
              value: 'MEDIUM',
              icon: 'minus',
              active: false,
              disabled: false,
              color: 'feedbackColorOrangePure'
            },
            {
              label: $translate.instant('HIGH'),
              value: 'HIGH',
              icon: 'chevron-up',
              active: false,
              disabled: false,
              color: 'feedbackColorRedPure'
            },
            {
              label: $translate.instant('URGENT'),
              value: 'URGENT',
              icon: 'chevron-up-double',
              active: false,
              disabled: false,
              color: 'feedbackColorRedPure'
            }
          ]
        }
      },
      {
        name: 'taskStatus',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('status'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('inboxStatus'),
              value: 'INBOX',
              icon: 'arrow-down',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('inProgress'),
              value: 'PROGRESS',
              icon: 'arts',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('underReview'),
              value: 'REVIEW',
              icon: 'clock',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('adjustments'),
              value: 'WAITING_ADM_ADJUST',
              icon: 'alert-triangle',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('done'),
              value: 'DONE',
              icon: 'check',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'taskTags',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('tags'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          loadButtonLabel: '',
          type: 'tag',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (name, top, skip) => TaskTagsService.getTaskTags({ top, skip, search: name })
      },
      {
        name: 'boards',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: boardAsDefaultValue ? [boardAsDefaultValue] : [],
        props: {
          label: $translate.instant('board'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          loadButtonLabel: '',
          type: 'board',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: () => BoardsService.getBoards()
      },
      {
        name: 'form',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('briefings'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => BriefingService.getCompanyBriefings('WORKFLOW', null, search, top, skip)
      },
      {
        name: 'assignees',
        type: 'INPUT_MULTISELECT',
        grouped: true,
        defaultValue: [],
        props: {
          label: $translate.instant('workflow.assignee'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'user',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
      },
      {
        name: 'authors',
        type: 'INPUT_MULTISELECT',
        grouped: true,
        defaultValue: [],
        props: {
          label: $translate.instant('workflow.requester'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'user',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
      }
    ]

    const campaignsFilters = [
      {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: showActiveAsDefaultValue ? activeItems : null,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('actives'),
              value: false,
              icon: 'success',
              active: !!showActiveAsDefaultValue,
              disabled: false
            },
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'campaignStatus',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('status'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('waiting'),
              value: 'WAITING',
              icon: 'clock',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('inProgress'),
              value: 'IN_PROGRESS',
              icon: 'target',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'campaignStatusRest',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('campaignsModule.status.late'),
              value: 'LATE',
              icon: 'clock',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('done'),
              value: 'FINISHED',
              icon: 'check',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'designer',
        type: 'INPUT_MULTISELECT',
        grouped: true,
        defaultValue: [],
        props: {
          label: $translate.instant('designer'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'designer',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search, permissions: ['DESIGNER'] })
      },
      {
        name: 'usersGroup',
        type: 'INPUT_MULTISELECT',
        grouped: true,
        defaultValue: [],
        props: {
          label: $translate.instant('usersGroupLabel'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'group',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => GroupService.getGroups(null, null, { searchTerm: search }, true)
      }
    ]

    let activitiesButton = {}
    let btnCreateTask = {}

    if ($scope.originModule !== 'campaigns') {
      activitiesButton = {
        type: 'button',
        btnType: 'secondary',
        label: $translate.instant('activities'),
        icon: 'clock',
        onClick: api._onOpenActivitiesDropdown
      }

      btnCreateTask = {
        type: 'button',
        btnType: 'primary',
        label: $translate.instant('createNew'),
        icon: 'plus',
        onClick: api._openCreateTask
      }
    }

    let btnCreateCampaign = null

    if ($scope.originModule === 'campaigns') {
      btnCreateCampaign = {
        icon: 'plus',
        type: 'button',
        btnType: 'primary',
        label: $translate.instant('campaignsModule.newCampaignBtn'),
        onClick: api._openNewCampaignDialog
      }
    }

    let leftButtons = null
    if ($scope.features?.['WORKFLOW.ACCESS'] && $scope.features?.['CAMPAIGNS.ACCESS']) {
      leftButtons = [
        {
          type: 'select-calendar-type',
          label: $translate.instant('selectPlaceholder'),
          onChange: api._onChangeCalendarType,
          options: [
            {
              label: $translate.instant('campaignsModule.title'),
              value: 'campaigns',
              active: $scope.originModule === 'campaigns'
            },
            {
              label: $translate.instant('requests'),
              value: 'workflow',
              active: $scope.originModule === 'workflow'
            }
          ]
        }
      ]
    }

    $scope.headerToolbar = {
      leftButtons,
      rightButtons: [
        ...($rootScope.isUserDesigner() ? [] : [activitiesButton]),
        btnCreateCampaign,
        btnCreateTask
      ],
      search: {
        filters: $scope.originModule === 'campaigns' ? campaignsFilters : filters,
        onFilter: api._onFilter,
        onSearch: api._onSearch
      }
    }

    $scope.headerTitle = $translate.instant('calendar')
  }

  function _onSearch (search) {
    const top = api._getTop()

    $scope.search = search

    const baseOptions = {
      $skip: $scope.tasks.index * top,
      $top: top,
      $sort: 'createdAt',
      $order: 'ASC',
      search: search,
      ...$scope.tasksFilters
    }

    const dateRange = {
      start: moment($scope.date).startOf($scope.viewMode).toISOString(),
      end: moment($scope.date).endOf($scope.viewMode).toISOString()
    }

    const options = {
      ...baseOptions,
      ...api._getDateRangeOptions(dateRange),
      role: $rootScope.isUserDesigner() ? 'DESIGNER' : null
    }

    if ($scope.originModule === 'campaigns') {
      $scope.loadingCampaigns = true
      CampaignService.getAllCampaigns(options)
        .then((response) => {
          $scope.campaigns = response.rows
          $scope.loadingCampaigns = false
        })
        .catch(api._defaultError)
    } else {
      $scope.loadingTasks = true
      TasksService.getTasks(options)
        .then(api._successGetTasks)
        .catch(api._defaultError)
    }
  }

  function _getDateRangeOptions (dateRange) {
    const { start, end } = dateRange

    if ($scope.viewMode === 'day') {
      return {
        deliveryDateStart: start,
        deliveryDateEnd: end,
        startDateStart: start,
        startDateEnd: end
      }
    }

    if ($scope.deliveryView === 'startDate') {
      return {
        startDateStart: start,
        startDateEnd: end
      }
    }

    if ($scope.deliveryView === 'deliveryDate') {
      return {
        deliveryDateStart: start,
        deliveryDateEnd: end
      }
    }

    return {}
  }

  function _onFilter (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    let boards = []
    if (filters.boards?.length === 1 && $stateParams.selectedBoard) {
      boards = [$stateParams.selectedBoard.id]
    } else if (filters.boards?.length > 0) {
      boards = filters.boards
    }

    const top = api._getTop()

    $scope.tasksFilters = {
      ...filters
    }

    const dateRange = {
      start: moment($scope.date).startOf($scope.viewMode).toISOString(),
      end: moment($scope.date).endOf($scope.viewMode).toISOString()
    }

    const taskTypes = filters.taskTypes

    const options = {
      ...filters,
      ...api._getDateRangeOptions(dateRange),
      $skip: $scope.tasks.index * top,
      $top: top,
      $sort: 'createdAt',
      $order: 'ASC',
      boards: boards,
      role: $rootScope.isUserDesigner() ? 'DESIGNER' : null,
      taskTypes: taskTypes[0]?.label ? [taskTypes[0].value, taskTypes[1].value] : taskTypes
    }

    if ($scope.originModule === 'campaigns') {
      $scope.loadingCampaigns = true

      return CampaignService.getAllCampaigns(options)
        .then((response) => {
          $scope.campaigns = response.rows
          $scope.loadingCampaigns = false
        })
        .catch(api._defaultError)
    } else {
      $scope.loadingTasks = true
      return TasksService.getTasks(options)
        .then(api._successGetTasks)
        .catch(api._defaultError)
    }
  }

  function handleClickOutsideActivitiesCard (event) {
    const activitiesContainer = document.querySelector('.marketing-calendar-activities-container')

    if (activitiesContainer && !activitiesContainer.contains(event.target)) {
      const clickedElement = event.target
      const isActivitiesButton = clickedElement.textContent && clickedElement.textContent.toLowerCase().includes('activities')
      if (!isActivitiesButton) {
        $scope.$apply(function () {
          $scope.showActivities = false
        })
      }
    }
  }

  function _loadActivity (limit = 10, offset, reset) {
    if (reset) {
      $scope.activities = []
      currentSkipActivities = 0
    }

    $scope.showLoadMore = false

    const filters = {
      $top: limit,
      $skip: offset,
      assignedToMe: $scope.activeTabActivities === 'assigned' ? 1 : null,
      ...api._getDateRangeOptions({
        start: moment($scope.date).startOf($scope.viewMode).toISOString(),
        end: moment($scope.date).endOf($scope.viewMode).toISOString()
      }),
      ...$scope.tasksFilters,
      role: $rootScope.isUserDesigner() ? 'DESIGNER' : null
    }

    TasksService.getTaskActivityBatch(filters).then(activities => {
      activities.rows.forEach(activity => {
        $scope.activities.push(activity)
      })
      activityCount = activities.count
      $scope.showLoadMore = $scope.showLoadMore || currentSkipActivities < activityCount
    }).catch(api._defaultError)
    currentSkipActivities = currentSkipActivities + limit
  }

  function _onOpenActivitiesDropdown () {
    $scope.showActivities = !$scope.showActivities
  }

  function _getDeliveryViewOptions () {
    $scope.deliveryViewOptions = [
      { id: 1, label: $translate.instant('marketingCalendar.filters.deliveryDate'), value: 'deliveryDate', active: $scope.originModule !== 'campaigns' },
      { id: 2, label: $translate.instant('marketingCalendar.filters.startDeliveryDate'), value: 'startDate', active: $scope.originModule === 'campaigns' }
    ]
  }

  function _openNewRequest (isRequestWithUser = false) {
    api.getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      ModalService.showModal({
        templateId: 'requestForm.html',
        templateUrl: '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$',
        controller: RequestFormDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          requestWithUser: isRequestWithUser,
          reloadTasksCalendar: true
        }
      }).then(() => {
        SegmentService.track('created-task', {
          type: 'REQUEST',
          page: 'calendar'
        })
        api._reloadTasksOnCreate(true)
      })
    })
  }

  function _openNewTask () {
    api.getNewTaskDialogController().then(({ NewTaskDialogController }) => {
      ModalService.showModal({
        templateId: 'newTask.html',
        templateUrl: '/workflow/dialogs/new-task/new-task-dialog.html?$$REVISION$$',
        controller: NewTaskDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          isCalendar: true
        }
      }).then(() => {
        SegmentService.track('created-task', {
          type: 'TASK',
          page: 'calendar'
        })
        api._reloadTasksOnCreate(true)
      })
    })
  }

  async function _getUserLocale () {
    try {
      const user = await $rootScope.getUser()
      $scope.locale = user.locale
    } catch (error) {
      console.log({ error })
      $scope.locale = null
    }
  }

  function _loadTasksPerRange (isLoadMore = false) {
    let startDate, endDate

    if (!isLoadMore) {
      $scope.tasks.items = []
    }

    let boards = []
    if ($scope.tasksFilters.boards?.length > 0) {
      boards = $scope.tasksFilters.boards
    } else if ($stateParams.selectedBoard) {
      boards = [$stateParams.selectedBoard.id]
    }

    const top = api._getTop()

    if ($scope.viewMode === 'month') {
      startDate = moment($scope.date).startOf($scope.viewMode).subtract(2, 'days').toISOString()
      endDate = moment($scope.date).endOf($scope.viewMode).add(2, 'days').toISOString()
    } else if ($scope.viewMode === 'day') {
      startDate = moment($scope.date).startOf($scope.viewMode).toISOString()
      endDate = startDate
    } else {
      startDate = moment($scope.date).startOf($scope.viewMode).toISOString()
      endDate = moment($scope.date).endOf($scope.viewMode).toISOString()
    }

    $scope.loadingTasks = true

    const taskTypes = $scope.tasksFilters?.taskTypes ? ($scope.tasksFilters.taskTypes[0]?.label
      ? $scope.tasksFilters.taskTypes.map(taskType => taskType.value) : $scope.tasksFilters.taskTypes) : ['REQUEST', 'TASK']

    const options = {
      $skip: $scope.tasks.index * top,
      $top: top,
      $sort: 'createdAt',
      $order: 'ASC',
      boards,
      search: $scope.search,
      ...$scope.tasksFilters,
      ...api._getDateRangeOptions({
        start: startDate,
        end: endDate
      }),
      role: $rootScope.isUserDesigner() ? 'DESIGNER' : null,
      taskTypes: taskTypes
    }

    TasksService.getTasks(options)
      .then((response) => api._successGetTasks(response, isLoadMore))
      .catch(api._defaultError)
  }

  function _successGetTasks (result, isLoadMore) {
    if (isLoadMore) {
      $scope.tasks.items.push(...result.rows)
    } else {
      $scope.tasks.items = result.rows
      $scope.tasks.index = 0
    }

    $scope.tasks.count = result.count
    $scope.loadingTasks = false
  }

  function _getActivityByType (type, operation, value, activity) {
    const isTypeStatus = type === 'STATUS'
    const isTypeColumn = type === 'COLUMN'
    const isTypeArchive = type === 'ARCHIVE'
    const isTypeTitle = type === 'TITLE'
    const isTypeDescription = type === 'DESCRIPTION'
    const isTypePriority = type === 'PRIORITY'
    const isTypeDeliveryDate = type === 'DELIVERY_DATE'
    const isTypeAttachment = type === 'ATTACHMENT'
    const isTypeComent = type === 'COMENT' || type === 'TASK_COMENT'
    const isTypeAssignee = type === 'ASSIGNEE'
    const isTypeNewBriefingVersion = type === 'NEW_BRIEFING_VERSION'
    const isTypeReaction = type === 'REACTION'
    const isTypeRelatedTask = type === 'RELATED_TASK'
    const isTypeRating = type === 'RATING'
    const isTypeAuthor = type === 'AUTHOR'
    const isTypeApproval = type === 'APPROVAL'
    const isTypeTimesheets = type === 'TIMESHEETS'
    const isTypeStartDate = type === 'START_DATE'

    const isOperationUpdate = operation === 'UPDATE'
    const isOperationCreate = operation === 'CREATE'
    const isOperationDelete = operation === 'DELETE'

    if (isTypeStatus && isOperationUpdate) {
      const statusMap = {
        REJECTED: 'taskHistoryMsgs.rejectedRequest',
        WAITING_RESPONSE: 'taskHistoryMsgs.requestApproval',
        WAITING_ADM_ADJUST: 'taskHistoryMsgs.requestAdjusts',
        WAITING_USER_ADJUST: 'taskHistoryMsgs.requestAdjusts',
        REVIEW: 'taskHistoryMsgs.review',
        INBOX: 'taskHistoryMsgs.approvedRequest',
        DONE: 'taskHistoryMsgs.done',
        PROGRESS: 'taskHistoryMsgs.reopenedTask'
      }
      if (statusMap[value]) {
        return $translate.instant(statusMap[value])
      }
      if (activity.approvalId) {
        return $translate.instant('taskHistoryMsgs.statusApproval', { status: $translate.instant(`taskHistoryMsgs.${value}`) })
      }
    }
    if (isTypeStatus && isOperationCreate) {
      return $translate.instant('taskHistoryMsgs.createTask')
    }

    if (isTypeColumn && isOperationUpdate) {
      if (!activity.columnName) {
        return $translate.instant('taskHistoryMsgs.move')
      }
      return $translate.instant('taskHistoryMsgs.moveTo', { columnName: activity.columnName })
    }
    if (isTypeColumn && isOperationCreate) {
      return $translate.instant('taskHistoryMsgs.moveToBoard', { boardName: activity.boardName })
    }

    if (isTypeArchive) {
      if (value === 'true') return $translate.instant('taskHistoryMsgs.archive')
      if (value === 'false') return $translate.instant('taskHistoryMsgs.unarchive')
    }

    if (isTypeTitle && isOperationUpdate) {
      return $translate.instant('taskHistoryMsgs.title')
    }

    if (isTypeDescription && (isOperationUpdate || isOperationCreate)) {
      return $translate.instant('taskHistoryMsgs.description')
    }

    if (isTypePriority && isOperationUpdate) {
      return $translate.instant('taskHistoryMsgs.priority')
    }

    if (isTypeDeliveryDate && (isOperationUpdate || isOperationCreate)) {
      return $translate.instant('taskHistoryMsgs.date')
    }

    if (isTypeAttachment && isOperationCreate) {
      if (activity.attachmentName || activity.from) {
        const attachmentName = activity.attachmentName || activity.from
        return $translate.instant('taskHistoryMsgs.addAttachmentName', { attachmentName })
      }
      return $translate.instant('taskHistoryMsgs.addAttachment')
    }
    if (isTypeAttachment && isOperationDelete) {
      return $translate.instant('taskHistoryMsgs.deleteAttachment')
    }

    if (isTypeComent && isOperationCreate) {
      return $translate.instant('taskHistoryMsgs.createComment')
    }
    if (isTypeComent && isOperationUpdate) {
      return $translate.instant('taskHistoryMsgs.updateComment')
    }
    if (isTypeComent && isOperationDelete) {
      return $translate.instant('taskHistoryMsgs.deleteComment')
    }

    if (isTypeAssignee && isOperationDelete) {
      return $translate.instant('taskHistoryMsgs.removeAssignee')
    }
    if (isTypeAssignee && isOperationCreate) {
      return $translate.instant('taskHistoryMsgs.addAssignee')
    }

    if (isTypeNewBriefingVersion && isOperationUpdate) {
      return $translate.instant('taskHistoryMsgs.newBriefingVersion')
    }

    if (isTypeReaction) {
      return $translate.instant('taskHistoryMsgs.reaction')
    }

    if (isTypeRelatedTask && isOperationCreate) {
      if (activity.relatedTaskTitle) {
        return $translate.instant('taskHistoryMsgs.addRelatedTaskTitle', { task: activity.relatedTaskTitle })
      }
      return $translate.instant('taskHistoryMsgs.addRelatedTask')
    }
    if (isTypeRelatedTask && isOperationDelete) {
      if (activity.relatedTaskTitle) {
        return $translate.instant('taskHistoryMsgs.removeRelatedTaskTitle', { task: activity.relatedTaskTitle })
      }
      return $translate.instant('taskHistoryMsgs.removeRelatedTask')
    }

    if (isTypeRating && isOperationCreate) {
      return $translate.instant('taskHistoryMsgs.ratedTask', { rate: activity.to })
    }

    if (isTypeAuthor && isOperationUpdate) {
      return $translate.instant('taskHistoryMsgs.changedAuthor', { authorName: activity.authorName })
    }

    if (isTypeApproval && isOperationCreate) {
      return $translate.instant('taskHistoryMsgs.createApproval')
    }
    if (isTypeApproval && isOperationUpdate) {
      return $translate.instant('taskHistoryMsgs.updateApproval')
    }
    if (isTypeApproval && isOperationDelete) {
      return $translate.instant('taskHistoryMsgs.deleteApproval')
    }

    if (isTypeTimesheets && isOperationCreate) {
      return $translate.instant('taskHistoryMsgs.createTimesheet')
    }
    if (isTypeTimesheets && isOperationUpdate) {
      return $translate.instant('taskHistoryMsgs.updateTimesheet')
    }
    if (isTypeTimesheets && isOperationDelete) {
      return $translate.instant('taskHistoryMsgs.deleteTimesheet')
    }
    if (isTypeStartDate && isOperationUpdate) {
      return $translate.instant('taskHistoryMsgs.updateStartDate')
    }
    if (isTypeStartDate && isOperationCreate) {
      return $translate.instant('taskHistoryMsgs.createStartDate')
    }
  }

  async function _showMarketingCalendarInfoCard () {
    const marketingCalendarInfoCardWasViewed = await UiElementViewLogService.getElementViewLog('calendar-info-card')
    if (!marketingCalendarInfoCardWasViewed) {
      $scope.showMarketingCalendarInfoCard = true
    }
  }

  function _reloadTasksOnCreate (created) {
    if (created) {
      api._loadTasksPerRange()
    }
  }

  function _defaultError (error) {
    console.log({ error })
    ToastService.defaultErrorToast()
  }

  function _getTop () {
    if ($scope.viewMode === 'day') {
      return 10
    } else {
      return 1000
    }
  }

  function _getAllCampaigns () {
    $scope.loadingCampaigns = true
    $scope.campaigns = []

    const dateRange = {
      start: moment($scope.date).startOf($scope.viewMode).toISOString(),
      end: moment($scope.date).endOf($scope.viewMode).toISOString()
    }

    const options = {
      ...$scope.tasksFilters,
      search: $scope.search,
      ...api._getDateRangeOptions(dateRange),
      $order: 'ASC'
    }

    CampaignService.getAllCampaigns(options).then(campaigns => {
      $scope.campaigns = campaigns.rows
      $scope.loadingCampaigns = false
    })
  }

  function _onChangeCalendarType (event) {
    $scope.originModule = event.detail.value
    api._getHeaderInfo()

    if ($scope.originModule === 'campaigns') {
      api._getAllCampaigns()
    } else {
      api._loadTasksPerRange()
    }
  }

  function _openNewCampaignDialog () {
    api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
      const createCampaignDialog = UdsModalService.createModal({
        controller: CreateCampaignDialogController,
        modalName: 'createCampaignDialog',
        data: {},
        onClose: () => {
          api._getAllCampaigns()
        }
      })

      createCampaignDialog.open()
    })
  }

  function _getLastOriginModule () {
    return localStorage.getItem('lastOriginModule') || 'workflow'
  }

  function _saveOriginModule () {
    localStorage.setItem('lastOriginModule', $scope.originModule)
  }

  function _getLastViewMode () {
    return localStorage.getItem('calendar-last-view-mode') || 'week'
  }

  function _saveViewMode () {
    localStorage.setItem('calendar-last-view-mode', $scope.viewMode)
  }

  $scope.$watch('originModule', () => {
    api._saveOriginModule()
  })

  $scope.$watch('viewMode', () => {
    api._saveViewMode()
  })

  $scope.handleBackClick = () => {
    $scope.tasksFilters = {}
    $scope.viewMode = $scope.lastViewMode

    if ($scope.originModule === 'campaigns') {
      _getAllCampaigns()
    } else {
      _loadTasksPerRange()
    }
  }

  $scope.checkShowdeliveryViewOptions = () => {
    return ($scope.viewMode !== 'day' && $scope.originModule !== 'campaigns')
  }

  function _openCreateTask (createMore = false) {
    api.getCreateTaskDialogController().then(({ CreateTaskDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: CreateTaskDialogController,
        modalName: 'createTaskDialogDirective',
        data: { createMore, isCalendar: true },
        onClose: (created) => {
          if (created) {
            api._loadTasksPerRange()
          }
        }
      })

      modal.open()
    })
  }

  $scope.onClickToday = () => {
    $scope.date = new Date()

    if ($scope.originModule === 'campaigns') {
      api._getAllCampaigns()
    } else {
      api._loadTasksPerRange()
    }
  }
}

export { MarketingCalendarController }
